'use client'; // Error components must be Client Components
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
// import { useTranslations } from 'next-intl';
import { ErrorBoundary } from '@castlery/fortress';
// todo:替换成fortress error page  @color
export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    // Log the error to an error reporting service
    Sentry.captureException(error);
  }, [error]);
  // const t = useTranslations('Error');

  return (
    <>
      <ErrorBoundary type={'page'} retryEvent={reset} dyDataCampaign="" />
    </>
  );
}
